import React, { FC } from "react";
import classNames from "classnames/dedupe";

import {
  Divider,
  FilterButton,
  Link,
  PageTitle,
  SvgIcon,
} from "../../components";

import {
  MainLogo,
  HamburgerSmallIcon,
  HeartWhiteIcon,
  ShoppingBagIcon,
} from "../../icons";

export type ScrollDirection = "up" | "down" | null;

export interface IMobileMenuDefaultCompact {
  isSticky?: boolean;
  scrollDir?: ScrollDirection;
}

const MobileMenuDefaultCompact: FC<IMobileMenuDefaultCompact> = (props) => {
  const { isSticky = false, scrollDir = null } = props;

  return (
    <div
      className={classNames("container-fluid mobile-menu-header compact", {
        sticky: isSticky,
        "scroll-down": scrollDir === "down",
      })}
    >
      <div className="mobile-menu-section">
        <Link href="/">
          <>
            <SvgIcon
              icon={MainLogo}
              isIcon={false}
              width={155}
              height={16}
              classes={{ root: "header-brand__desktop" }}
            />
            <SvgIcon
              icon={MainLogo}
              isIcon={false}
              width={116}
              height={13}
              classes={{ root: "header-brand__mobile" }}
            />
          </>
        </Link>
        <div className="mobile-menu-header-main-icon-container">
          <SvgIcon icon={HeartWhiteIcon} />
          <SvgIcon icon={ShoppingBagIcon} />
          <SvgIcon icon={HamburgerSmallIcon} />
        </div>
      </div>

      <div className="mobile-menu-section">
        <PageTitle
          title="MENS RUNNING SHOES SECOND LINE"
          productCount={10234}
        />
        <FilterButton title="SORT & FILTER" size="small" count={6} />
      </div>

      <Divider />
    </div>
  );
};

export default MobileMenuDefaultCompact;
